import Vue from 'vue'
import Vuex from 'vuex'
import ajaxManager from 'devegram-vuex-ajax-manager'
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ajaxManager,
  }
})
